export default "__VITE_ASSET___Pco2BAI__"